var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$validateText(_vm.data))?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.data,
        trigger: 'manual',
        show: _vm.show
    }),expression:"{\n        content: data,\n        trigger: 'manual',\n        show: show\n    }"}],staticClass:"tooltip-wrapper",on:{"mouseover":function($event){_vm.show = true},"click":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_vm._t("default",function(){return [_c('i',{staticClass:"fa-solid fa-info-circle tooltip-icon"})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }